// extracted by mini-css-extract-plugin
export default {"Comment":"styles_Comment__xHhSE","Comment__box":"styles_Comment__box__LKYsT","Comment__boxGreen":"styles_Comment__boxGreen__COElZ"};